import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { APP_VERSION } from 'src/version';

@Injectable()
export class VersionInterceptor implements HttpInterceptor {
    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const headersConfig = { 'API-Version-PreCondition': `${APP_VERSION.version}` };
        const requestWithVersion = request.clone({ setHeaders: headersConfig });
        return next.handle(requestWithVersion);
    }
}
